import React, { useEffect, useState } from "react";
import axios from "axios";
import CourseView from "../../components/SuperAdmin/View";

function Courses() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetch = async () => {
      try {
        axios.defaults.withCredentials = true;
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/course/get-all-course-ids`
        );
        setData(response.data.courses);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    };
    fetch();
  }, []);

    if(loading) return <p>Loading...</p>;
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-6 ml-5">Admin Dashboard</h1>
      <CourseView title={"Courses"} data={data} />
    </div>
  );
}

export default Courses;
